import { createActions } from "redux-actions";

const {
  getInitData
} = createActions(
  "GET_INIT_DATA"
);

export {
  getInitData
};
